// extracted by mini-css-extract-plugin
export var border = "_e-8";
export var brand = "_e-t";
export var button = "_e-l";
export var center = "_e-a";
export var centered = "_e-6";
export var closeButton = "_e-c";
export var disabledWrapper = "_e-m";
export var error = "_e-p";
export var extraLarge = "_e-4";
export var extraSmall = "_e-1";
export var fill = "_e-i";
export var footer = "_e-h";
export var footerAction = "_e-j";
export var footerButtons = "_e-k";
export var header = "_e-7";
export var headerWithClose = "_e-d";
export var icon = "_e-o";
export var info = "_e-s";
export var inline = "_e-9";
export var large = "_e-3";
export var main = "_e-e";
export var modal = "_e-0";
export var nearFull = "_e-5";
export var neutral = "_e-u";
export var noPadding = "_e-g";
export var none = "_e-v";
export var scrollable = "_e-f";
export var small = "_e-2";
export var success = "_e-r";
export var tight = "_e-n";
export var titleIcon = "_e-b";
export var warn = "_e-q";